var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#043A53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2937 12.9865L21.0351 21.482C20.7436 21.7235 20.3769 21.8557 19.9984 21.8557C19.6198 21.8557 19.2531 21.7235 18.9616 21.482L8.70788 12.9865C8.65286 13.1521 8.62487 13.3255 8.625 13.5V26.5C8.625 26.931 8.7962 27.3443 9.10095 27.649C9.4057 27.9538 9.81902 28.125 10.25 28.125H29.75C30.181 28.125 30.5943 27.9538 30.899 27.649C31.2038 27.3443 31.375 26.931 31.375 26.5V13.5C31.3757 13.3256 31.3482 13.1522 31.2937 12.9865ZM10.25 10.25H29.75C30.612 10.25 31.4386 10.5924 32.0481 11.2019C32.6576 11.8114 33 12.638 33 13.5V26.5C33 27.362 32.6576 28.1886 32.0481 28.7981C31.4386 29.4076 30.612 29.75 29.75 29.75H10.25C9.38805 29.75 8.5614 29.4076 7.9519 28.7981C7.34241 28.1886 7 27.362 7 26.5V13.5C7 12.638 7.34241 11.8114 7.9519 11.2019C8.5614 10.5924 9.38805 10.25 10.25 10.25ZM9.90875 11.875L18.9698 19.3549C19.26 19.5946 19.6244 19.7261 20.0008 19.727C20.3771 19.7279 20.7422 19.5981 21.0335 19.3597L30.1855 11.875H9.90875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailicon);
export default __webpack_public_path__ + "static/media/emailicon.9ce3143f5d75a2d5cbfb3417359314a1.svg";
export { ForwardRef as ReactComponent };